// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as RelayRouter__Context from "./RelayRouter__Context.mjs";
import * as RelayRouter__Internal from "./RelayRouter__Internal.mjs";

var Route_loading_failed = /* @__PURE__ */Caml_exceptions.create("RelayRouter__Internal__DeclarationsSupport.Route_loading_failed");

var RouteRenderer = {};

function doLoadRouteRenderer(loadFn, routeName, loadedRouteRenderers) {
  var promise = loadFn();
  loadedRouteRenderers.set(routeName, {
        TAG: "Pending",
        _0: promise
      });
  return promise.then(function (routeRenderer) {
              loadedRouteRenderers.set(routeName, {
                    TAG: "Loaded",
                    _0: routeRenderer
                  });
              return Promise.resolve();
            });
}

function preloadCode(loadedRouteRenderers, routeName, loadRouteRenderer, makePrepareProps, environment, pathParams, queryParams, $$location) {
  var apply = function (routeRenderer) {
    var preparedProps = makePrepareProps(environment, pathParams, queryParams, $$location);
    var prepareCode = routeRenderer.prepareCode;
    if (prepareCode !== undefined) {
      return prepareCode(preparedProps);
    } else {
      return [];
    }
  };
  var match = loadedRouteRenderers.get(routeName);
  if (match !== undefined && typeof match === "object") {
    if (match.TAG === "Pending") {
      return match._0.then(function (routeRenderer) {
                  return Promise.resolve(apply(routeRenderer));
                });
    }
    var routeRenderer = match._0;
    return new Promise((function (resolve, param) {
                  resolve(apply(routeRenderer));
                }));
  }
  return loadRouteRenderer().then(function () {
              var match = loadedRouteRenderers.get(routeName);
              if (match !== undefined) {
                if (typeof match !== "object") {
                  throw {
                        RE_EXN_ID: Route_loading_failed,
                        _1: "Invalid state after loading route renderer. Please report this error.",
                        Error: new Error()
                      };
                }
                if (match.TAG !== "Pending") {
                  return Promise.resolve(apply(match._0));
                }
                throw {
                      RE_EXN_ID: Route_loading_failed,
                      _1: "Invalid state after loading route renderer. Please report this error.",
                      Error: new Error()
                    };
              } else {
                throw {
                      RE_EXN_ID: Route_loading_failed,
                      _1: "Invalid state after loading route renderer. Please report this error.",
                      Error: new Error()
                    };
              }
            });
}

function makePrepareAssets(loadedRouteRenderers, prepareDisposeTimeout) {
  var preparedMap = new Map();
  var getPrepared = function (routeKey) {
    return preparedMap.get(routeKey);
  };
  var disposeOfPrepared = function (routeKey) {
    var match = preparedMap.get(routeKey);
    if (match !== undefined) {
      match.disposables.forEach(function (dispose) {
            dispose();
          });
      return ;
    }
    
  };
  var $$clearTimeout$1 = function (routeKey) {
    var match = preparedMap.get(routeKey);
    if (match === undefined) {
      return ;
    }
    var timeoutId = match.timeout;
    if (timeoutId !== undefined) {
      clearTimeout(Caml_option.valFromOption(timeoutId));
      return ;
    }
    
  };
  var expirePrepared = function (routeKey) {
    disposeOfPrepared(routeKey);
    $$clearTimeout$1(routeKey);
    preparedMap.delete(routeKey);
  };
  var addPrepared = function (routeKey, disposables, intent, render) {
    var match = preparedMap.get(routeKey);
    var match$1;
    var exit = 0;
    if (intent === "Render") {
      if (match !== undefined) {
        $$clearTimeout$1(routeKey);
        var oldDisposables = match.disposables;
        setTimeout((function () {
                oldDisposables.forEach(function (dispose) {
                      dispose();
                    });
              }), 0);
        match$1 = [
          {
            disposables: disposables,
            render: render,
            timeout: match.timeout
          },
          false
        ];
      } else {
        exit = 1;
      }
    } else if (match !== undefined) {
      match$1 = [
        undefined,
        false
      ];
    } else {
      exit = 1;
    }
    if (exit === 1) {
      match$1 = [
        {
          disposables: disposables,
          render: render,
          timeout: undefined
        },
        intent === "Preload"
      ];
    }
    var preparedRecord = match$1[0];
    if (preparedRecord !== undefined) {
      preparedMap.set(routeKey, preparedRecord);
      if (match$1[1]) {
        $$clearTimeout$1(routeKey);
        var r = preparedMap.get(routeKey);
        if (r !== undefined) {
          r.timeout = Caml_option.some(setTimeout((function () {
                      expirePrepared(routeKey);
                    }), prepareDisposeTimeout));
          return ;
        } else {
          return ;
        }
      } else {
        return ;
      }
    }
    
  };
  var prepareRoute = function (environment, pathParams, queryParams, $$location, makePrepareProps, makeRouteKey, getPrepared, routeName, loadRouteRenderer, intent) {
    var preparedProps = makePrepareProps(environment, pathParams, queryParams, $$location);
    var routeKey = makeRouteKey(pathParams, queryParams);
    var match = getPrepared(routeKey);
    var exit = 0;
    if (match !== undefined) {
      if (intent !== "Render") {
        return {
                routeKey: routeKey,
                render: match.render
              };
      }
      exit = 1;
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var preparedRef = {
        contents: "NotInitiated"
      };
      var doPrepare = function (routeRenderer) {
        var prepareCode = routeRenderer.prepareCode;
        if (prepareCode !== undefined) {
          prepareCode(preparedProps);
        }
        var prepared = routeRenderer.prepare(preparedProps);
        preparedRef.contents = {
          TAG: "Loaded",
          _0: prepared
        };
        return prepared;
      };
      var match$1 = loadedRouteRenderers.get(routeName);
      var exit$1 = 0;
      if (match$1 !== undefined && typeof match$1 === "object") {
        if (match$1.TAG === "Pending") {
          var preparePromise = match$1._0.then(function (routeRenderer) {
                return Promise.resolve(doPrepare(routeRenderer));
              });
          preparedRef.contents = {
            TAG: "Pending",
            _0: preparePromise
          };
        } else {
          doPrepare(match$1._0);
        }
      } else {
        exit$1 = 2;
      }
      if (exit$1 === 2) {
        var preparePromise$1 = loadRouteRenderer().then(function () {
              var match = loadedRouteRenderers.get(routeName);
              if (match !== undefined) {
                if (typeof match !== "object") {
                  throw {
                        RE_EXN_ID: Route_loading_failed,
                        _1: "Route renderer not in loaded state even though it should be. This should be impossible, please report this error.",
                        Error: new Error()
                      };
                }
                if (match.TAG !== "Pending") {
                  return Promise.resolve(doPrepare(match._0));
                }
                throw {
                      RE_EXN_ID: Route_loading_failed,
                      _1: "Route renderer not in loaded state even though it should be. This should be impossible, please report this error.",
                      Error: new Error()
                    };
              } else {
                throw {
                      RE_EXN_ID: Route_loading_failed,
                      _1: "Route renderer not in loaded state even though it should be. This should be impossible, please report this error.",
                      Error: new Error()
                    };
              }
            });
        preparedRef.contents = {
          TAG: "Pending",
          _0: preparePromise$1
        };
      }
      var render = function (childRoutes) {
        var match = RelayRouter__Context.useRouterContext();
        var subscribeToEvent = match.subscribeToEvent;
        React.useEffect((function () {
                $$clearTimeout$1(routeKey);
                return subscribeToEvent(function ($$event) {
                            switch ($$event.TAG) {
                              case "OnBeforeNavigation" :
                              case "RestoreScroll" :
                                  return ;
                              case "OnRouteWillUnmount" :
                                  if (routeKey === $$event.routeKey) {
                                    setTimeout((function () {
                                            expirePrepared(routeKey);
                                          }), 0);
                                    return ;
                                  } else {
                                    return ;
                                  }
                              
                            }
                          });
              }), [subscribeToEvent]);
        var match$1 = loadedRouteRenderers.get(routeName);
        var match$2 = preparedRef.contents;
        if (typeof match$2 !== "object") {
          console.log("Warning: Tried to render route with prepared not initiated. This should not happen, prepare should be called prior to any rendering.");
          return null;
        }
        if (match$2.TAG === "Pending") {
          throw(match$2._0);
          return null;
        }
        if (match$1 !== undefined) {
          if (typeof match$1 !== "object") {
            console.log("Warning: Invalid state");
            return null;
          }
          if (match$1.TAG !== "Pending") {
            return match$1._0.render(Object.assign({
                            prepared: match$2._0
                          }, {
                            childRoutes: childRoutes
                          }, preparedProps));
          }
          console.log("Warning: Invalid state");
          return null;
        } else {
          console.log("Warning: Invalid state");
          return null;
        }
      };
      var prepared = preparedRef.contents;
      var tmp;
      tmp = typeof prepared !== "object" ? [] : (
          prepared.TAG === "Pending" ? [] : RelayRouter__Internal.extractDisposables(prepared._0)
        );
      addPrepared(routeKey, tmp, intent, render);
      return {
              routeKey: routeKey,
              render: render
            };
    }
    
  };
  return {
          getPrepared: getPrepared,
          prepareRoute: prepareRoute
        };
}

export {
  RouteRenderer ,
  doLoadRouteRenderer ,
  preloadCode ,
  makePrepareAssets ,
}
/* react Not a pure module */
